import GoalDropdown from './GoalDropdown'
import { FormControlProps } from './FormControls'

type FormControlsLegacyProps = FormControlProps & {
  handleGenericStateUpdate: (_key: string, _value: string | number) => void
  handleGenericStatesUpdate: (
    _key: string[],
    _value: (string | number)[],
  ) => void
}

export default function FormControlsLegacy({
  rebuttalState,
  currentLanguage,
  isPayer,
  roleOverwrite,
  translateControl,
  formatCurrency,
  handleOnChangePayer,
  handleOnChangeGoal1,
  handleOnChangeGoal2,
  handleGenericStateUpdate,
  handleGenericStatesUpdate,
  resetForm,
}: FormControlsLegacyProps): React.ReactNode {
  const handleOnChangeTotalDebt = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldsToUpdate = ['debtOwed', 'totalOwed']
    const safeValue = e.target.value.replace('$', '').replace(',', '')
    const updatedValues = [safeValue, (parseInt(safeValue) * 3).toString()]
    handleGenericStatesUpdate(fieldsToUpdate, updatedValues)
  }

  const handleOnChangeProgramTerm = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const fieldsToUpdate = ['programLength', 'programTotal']
    const safeValue =
      parseInt(
        e.target.value.replace(/[months|meses]*/g, '').replace(' ', ''),
      ) || 0
    const updatedValues = [
      safeValue,
      safeValue * rebuttalState.programPayment || 0,
    ]

    handleGenericStatesUpdate(fieldsToUpdate, updatedValues)
  }

  const handleOnChangeMonthlyPayment = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const safeValue = e.target.value.replace('$', '').replace(',', '')
    handleGenericStateUpdate('monthlyPayment', safeValue)
  }

  const handleOnChangeProgramPayment = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const safeValue = e.target.value.replace('$', '').replace(',', '')
    const fieldsToUpdate = ['programPayment', 'programTotal']
    const updatedValues = [
      safeValue,
      parseInt(safeValue) * rebuttalState.programLength || 0,
    ]

    handleGenericStatesUpdate(fieldsToUpdate, updatedValues)
  }

  const handleOnChangeYears = (e: React.ChangeEvent<HTMLInputElement>) => {
    const safeValue = parseInt(e.target.value) || 0
    console.log(safeValue)
    handleGenericStateUpdate('yearsPaid', safeValue)
  }

  const handleOnChangeMonths = (e: React.ChangeEvent<HTMLInputElement>) => {
    const safeValue = parseInt(e.target.value) || 0
    handleGenericStateUpdate('monthsPaid', safeValue)
  }

  const handleOnLoanAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const safeValue =
      parseInt(e.target.value.replace('$', '').replace(',', '')) || 0
    handleGenericStateUpdate('loanAmount', safeValue)
  }

  const handleOnChangeLoanTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    const safeValue =
      parseInt(
        e.target.value.replace(/[months|meses]*/g, '').replace(' ', ''),
      ) || 0
    handleGenericStateUpdate('loanTerm', safeValue)
  }

  const handleOnChangeLoanPayment = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const safeValue =
      parseInt(e.target.value.replace('$', '').replace(',', '')) || 0
    handleGenericStateUpdate('loanAmount', safeValue)
  }

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value.indexOf('$') != -1) {
      e.target.setSelectionRange(1, e.target.value.length)
    } else if (e.target.value.indexOf(' m') != -1) {
      const indexOfSpecialCharacter = e.target.value.indexOf(' m')
      e.target.setSelectionRange(0, indexOfSpecialCharacter)
    }
  }

  return (
    <table>
      <tbody>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Total Debt')}
            </div>
            <div className="input-container">
              <input
                value={formatCurrency(rebuttalState.debtOwed)}
                onChange={handleOnChangeTotalDebt}
                style={{ backgroundColor: 'rgb(251,230,168)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Program Term')}
            </div>
            <div className="input-container">
              <input
                // ref={monthsRef}
                // onClick={handleOnClickProgramTerm}
                value={`${rebuttalState.programLength} ${currentLanguage === 'en' ? 'months' : 'meses'}`}
                onChange={handleOnChangeProgramTerm}
                // onFocus={handleOnFocusProgramTerm}
                style={{ backgroundColor: 'rgb(251,230,168)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Monthly Payment')}
            </div>
            <div className="input-container">
              <input
                value={formatCurrency(rebuttalState.monthlyPayment)}
                onChange={handleOnChangeMonthlyPayment}
                style={{ backgroundColor: 'rgb(251,230,168)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Program Payment')}
            </div>
            <div className="input-container">
              <input
                value={formatCurrency(rebuttalState.programPayment)}
                onChange={handleOnChangeProgramPayment}
                style={{ backgroundColor: 'rgb(251,230,168)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Payer Status')}
            </div>
            <div className="input-container">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isPayer}
                  onChange={handleOnChangePayer}
                />
                <span className="slider"></span>
              </label>
            </div>
          </td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Program Cost')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={formatCurrency(rebuttalState.programTotal || 0)}
                style={{ backgroundColor: 'rgb(189,215,170)' }}
                type="text"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              <br />
              <b>{translateControl(currentLanguage, 'How Long?')}</b>{' '}
              {translateControl(currentLanguage, 'Years')}
            </div>
            <div className="input-container">
              <input
                value={rebuttalState.yearsPaid}
                onChange={handleOnChangeYears}
                style={{ backgroundColor: 'rgb(251,230,168)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Months')}
            </div>
            <div className="input-container">
              <input
                value={rebuttalState.monthsPaid}
                onChange={handleOnChangeMonths}
                style={{ backgroundColor: 'rgb(251,230,168)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Monthly Savings')}
            </div>
            <div className="input-container">
              <input
                readOnly
                style={{ backgroundColor: 'rgb(189,215,170)' }}
                type="text"
                value={formatCurrency(
                  rebuttalState.monthlyPayment - rebuttalState.programPayment ||
                    0,
                )}
                onFocus={handleOnFocus}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Total Savings')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={formatCurrency(
                  rebuttalState.totalOwed - rebuttalState.programTotal || 0,
                )}
                style={{ backgroundColor: 'rgb(189,215,170)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Annual Payments')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={formatCurrency(rebuttalState.monthlyPayment * 12 || 0)}
                style={{ backgroundColor: 'rgb(238,205,204)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Principal Savings')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={formatCurrency(
                  rebuttalState.debtOwed - rebuttalState.programTotal || 0,
                )}
                style={{ backgroundColor: 'rgb(189,215,170)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Total Paid So Far')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={formatCurrency(
                  rebuttalState.monthlyPayment *
                    (rebuttalState.yearsPaid * 12 + rebuttalState.monthsPaid) ||
                    0,
                )}
                style={{ backgroundColor: 'rgb(238,205,204)' }}
                type="text"
              />
            </div>
          </td>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'Time Saved')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={`${Math.floor((240 - rebuttalState.programLength) / 12)} ${currentLanguage === 'en' ? 'years' : ' años'} `}
                style={{ backgroundColor: 'rgb(189,215,170)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="input-label">
              {translateControl(currentLanguage, 'What you will Pay')}
            </div>
            <div className="input-container">
              <input
                readOnly
                value={formatCurrency(rebuttalState.totalOwed || 0)}
                style={{ backgroundColor: 'rgb(238,205,204)' }}
                type="text"
                onFocus={handleOnFocus}
              />
            </div>
          </td>
          <td></td>
        </tr>
        {roleOverwrite === 'newhire' && (
          <>
            <tr>
              <td
                colSpan={2}
                style={{ textAlign: 'center', paddingTop: '2rem' }}
              >
                {translateControl(currentLanguage, 'Loan Terms')}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                <div className="input-label">
                  {translateControl(currentLanguage, 'Loan Amount')}
                </div>
                <div className="input-container">
                  <input
                    onChange={handleOnLoanAmountChange}
                    value={formatCurrency(rebuttalState.loanAmount || 0)}
                    style={{ backgroundColor: 'rgb(251,230,168)' }}
                    type="text"
                    onFocus={handleOnFocus}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                <div className="input-label">
                  {translateControl(currentLanguage, 'Loan Term')}
                </div>
                <div className="input-container">
                  <input
                    // ref={loanMonthsRef}
                    // onClick={handleOnClickLoanTerm}
                    value={`${rebuttalState.loanLength} ${currentLanguage === 'en' ? 'months' : 'meses'}`}
                    onChange={handleOnChangeLoanTerm}
                    // onFocus={handleOnFocusLoanTerm}
                    style={{ backgroundColor: 'rgb(251,230,168)' }}
                    type="text"
                    onFocus={handleOnFocus}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                <div className="input-label">
                  {translateControl(currentLanguage, 'Loan Monthly Payment')}
                </div>
                <div className="input-container">
                  <input
                    onChange={handleOnChangeLoanPayment}
                    value={formatCurrency(rebuttalState.loanPayment || 0)}
                    style={{ backgroundColor: 'rgb(251,230,168)' }}
                    type="text"
                    onFocus={handleOnFocus}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td
                colSpan={2}
                style={{ textAlign: 'center', paddingTop: '2rem' }}
              >
                Goals
              </td>
            </tr>
            {/* GOAL 1 */}
            <tr>
              <td colSpan={2}>
                <GoalDropdown
                  handleGoalChange={handleOnChangeGoal1}
                  goalValue={rebuttalState.goal1}
                />
              </td>
            </tr>

            {/* GOAL 2 */}
            <tr>
              <td colSpan={2}>
                <GoalDropdown
                  handleGoalChange={handleOnChangeGoal2}
                  goalValue={rebuttalState.goal2}
                />
              </td>
            </tr>
          </>
        )}
        <tr>
          <td colSpan={2} style={{ textAlign: 'center', paddingTop: '2rem' }}>
            <button
              type="button"
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                marginBottom: '24px',
              }}
              onClick={resetForm}
            >
              {translateControl(currentLanguage, 'Reset')}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
